import { CurrentEligibilityScholarshipUpdateDTO, ScholarshipRequirementType } from '@studyportals/eligibility-model';

export default class EligibilityModelUtils {
	public updatedEligibilityItems = (
		eligibility: CurrentEligibilityScholarshipUpdateDTO
	): ScholarshipRequirementType[] | null => {
		const eligibilityTypes = Object.keys(eligibility) as ScholarshipRequirementType[];
		const requirements = eligibilityTypes.filter((requirement) => eligibility[requirement]);

		if (!requirements) return null;
		return requirements;
	};
}
